import { appPaths } from "@/constants/paths";
import { useLogOut } from "@/queries/use-Logout";
import { getRefreshToken } from "@/utils/auth-storage";
import { clearSession } from "@/utils/session-teardown";
import { useNavigate } from "react-router-dom";
import { DisclosureHost } from "../hooks/use-disclosure";
import StatusModal from "./StatusModal";

interface LogOutModalProps {
  disclosureHost: DisclosureHost;
}

const LogOutModal = ({ disclosureHost }: LogOutModalProps) => {
  const { mutateAsync: logout } = useLogOut();
  const navigate = useNavigate();

  return (
    <StatusModal
      w="28rem"
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      onConfirmation={async () => {
        const refreshToken = getRefreshToken();

        await logout({ refreshToken }).then(() => {
          disclosureHost.close();

          clearSession();
          navigate(appPaths.login, { replace: true });
        });
      }}
      iconColor="primary.main"
      content={"You want to Sign Out?"}
    />
  );
};

export default LogOutModal;
